import React from 'react'
import styles from './noResults.scss'
import noResultsImg from 'resources/images/icn-no-result.svg'
import i18n from 'lib/i18n'
const _ = i18n('noResults')

const NoResults = ({type}) => (
	<div className={styles.msgContainer}>
		<div className={styles.msg}>
			<div className={styles.imageContainer}>
				<img src={noResultsImg}/>
			</div>
			<div className={styles.textContainer}>
				{_(type)}
			</div>
		</div>
	</div>
)
NoResults.propTypes = {
	type: React.PropTypes.string.isRequired,
}

export default NoResults



// WEBPACK FOOTER //
// ./components/noResults.jsx